import { Typography } from "@mui/material"
import Modal, { Breakpoint } from "../Modals"

type PropertiesViewerProps = {
    show: boolean,
    title: string,
    onClose: () => any
    properties: { label: string, id: any, value: any }[],
    fullWidth?: boolean,
    maxWidth? : false | undefined | Breakpoint
}
const PropertiesViewer = (props: PropertiesViewerProps) => {
    const { onClose, properties, show, title, fullWidth, maxWidth } = props
    return <Modal open={show} maxWidth={maxWidth} onClose={onClose} title={title}  fullwidth={Boolean(fullWidth)}>
        <div style={{ display: 'flex', padding: '10px 0', gap: '10px', flexDirection: 'column', width: '100%', minWidth: '300px' }}>
            {
                properties.map(property => {
                    return <div key={'property_viewer_' + property.id} style={{ width: '100%', display: 'flex', borderRadius: '10px', background: '#f5f5f5', border: '1px solid #d4d4d4' }}>
                        <span style={{ width: '50%', background: '#e1e1e1', padding: '10px', borderRadius: '10px 0 0 10px' }}>
                            <Typography variant="body1">
                                {property.label}
                            </Typography>
                        </span>
                        <span style={{ width: '50%', padding: '10px' }}>
                            <Typography variant="body1">
                                {property.value}
                            </Typography>
                        </span>
                    </div>
                })
            }
        </div>
    </Modal>
}

export default PropertiesViewer